(function () {
  var TAP_THRESHOLD = 10; // px of movement allowed before it's a drag, not a tap

  function initCarousel(root) {
    var track = root.querySelector('[data-card-carousel-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-card-carousel-dots] .card-carousel__dot'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('.card-carousel__slide'));
    var productUrl = root.getAttribute('data-product-url');
    if (!track || slides.length < 2) return;

    var ticking = false;

    function updateActiveDot() {
      var trackRect = track.getBoundingClientRect();
      var centerX = trackRect.left + trackRect.width / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(slideCenter - centerX);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === closestIndex);
      });

      ticking = false;
    }

    track.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateActiveDot);
          ticking = true;
        }
      },
      { passive: true }
    );

    // Tap-to-navigate: the carousel sits above this theme's own
    // "whole card is clickable" overlay, so it now owns all touch/
    // click events in the image area. A plain tap (no meaningful
    // drag in either direction) should still open the product page;
    // a real swipe should just scroll the carousel as normal.
    if (productUrl) {
      var startX = 0;
      var startY = 0;
      var pointerId = null;

      track.addEventListener('pointerdown', function (e) {
        startX = e.clientX;
        startY = e.clientY;
        pointerId = e.pointerId;
      });

      track.addEventListener('pointerup', function (e) {
        if (e.pointerId !== pointerId) return;
        var deltaX = Math.abs(e.clientX - startX);
        var deltaY = Math.abs(e.clientY - startY);
        if (deltaX < TAP_THRESHOLD && deltaY < TAP_THRESHOLD) {
          window.location.href = productUrl;
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-card-carousel]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
